import _toConsumableArray from "/tmp/caradvise-production/27/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "/tmp/caradvise-production/27/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { dropUndefinedKeys } from '@sentry/utils';
/**
 * Generate bucket key from metric properties.
 */

function getBucketKey(metricType, name, unit, tags) {
  var stringifiedTags = Object.entries(dropUndefinedKeys(tags)).sort(function (a, b) {
    return a[0].localeCompare(b[0]);
  });
  return "".concat(metricType).concat(name).concat(unit).concat(stringifiedTags);
}
/* eslint-disable no-bitwise */

/**
 * Simple hash function for strings.
 */


function simpleHash(s) {
  var rv = 0;

  for (var i = 0; i < s.length; i++) {
    var c = s.charCodeAt(i);
    rv = (rv << 5) - rv + c;
    rv &= rv;
  }

  return rv >>> 0;
}
/* eslint-enable no-bitwise */

/**
 * Serialize metrics buckets into a string based on statsd format.
 *
 * Example of format:
 * metric.name@second:1:1.2|d|#a:value,b:anothervalue|T12345677
 * Segments:
 * name: metric.name
 * unit: second
 * value: [1, 1.2]
 * type of metric: d (distribution)
 * tags: { a: value, b: anothervalue }
 * timestamp: 12345677
 */


function serializeMetricBuckets(metricBucketItems) {
  var out = '';

  var _iterator = _createForOfIteratorHelper(metricBucketItems),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var item = _step.value;
      var tagEntries = Object.entries(item.tags);
      var maybeTags = tagEntries.length > 0 ? "|#".concat(tagEntries.map(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
            key = _ref2[0],
            value = _ref2[1];

        return "".concat(key, ":").concat(value);
      }).join(',')) : '';
      out += "".concat(item.name, "@").concat(item.unit, ":").concat(item.metric, "|").concat(item.metricType).concat(maybeTags, "|T").concat(item.timestamp, "\n");
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return out;
}
/** Sanitizes units */


function sanitizeUnit(unit) {
  return unit.replace(/[^\w]+/gi, '_');
}
/** Sanitizes metric keys */


function sanitizeMetricKey(key) {
  return key.replace(/[^\w\-.]+/gi, '_');
}

function sanitizeTagKey(key) {
  return key.replace(/[^\w\-./]+/gi, '');
}

var tagValueReplacements = [['\n', '\\n'], ['\r', '\\r'], ['\t', '\\t'], ['\\', '\\\\'], ['|', "\\u{7c}"], [',', "\\u{2c}"]];

function getCharOrReplacement(input) {
  var _iterator2 = _createForOfIteratorHelper(tagValueReplacements),
      _step2;

  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var _step2$value = _slicedToArray(_step2.value, 2),
          search = _step2$value[0],
          replacement = _step2$value[1];

      if (input === search) {
        return replacement;
      }
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }

  return input;
}

function sanitizeTagValue(value) {
  return _toConsumableArray(value).reduce(function (acc, char) {
    return acc + getCharOrReplacement(char);
  }, '');
}
/**
 * Sanitizes tags.
 */


function sanitizeTags(unsanitizedTags) {
  var tags = {};

  for (var key in unsanitizedTags) {
    if (Object.prototype.hasOwnProperty.call(unsanitizedTags, key)) {
      var sanitizedKey = sanitizeTagKey(key);
      tags[sanitizedKey] = sanitizeTagValue(String(unsanitizedTags[key]));
    }
  }

  return tags;
}

export { getBucketKey, sanitizeMetricKey, sanitizeTags, sanitizeUnit, serializeMetricBuckets, simpleHash };